<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Vessel Certficates &nbsp;
          <add-button
            link="/planned-maintenance/vessel-certificates/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Maintenance</li>
          <li class="breadcrumb-item">Vessel Certficates</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body row">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
          <div class="col-md-4">
            <div style="float: right">
              <a
                href="#"
                class="btn btn-primary"
                v-if="ExportVesselCertficates.length == 0"
                @click="exportToExcel"
              >
                <span v-if="isExcelloading">
                  <div class="d-flex align-items-center">
                    <strong>Generating Excel</strong>
                    &nbsp;
                    <div
                      class="
                        spinner-border
                        text-light
                        spinner-border-sm
                        ms-auto
                      "
                      role="status"
                      aria-hidden="true"
                    ></div>
                  </div>
                </span>
                <span v-else>Generate Excel</span>
              </a>
              <download-excel
                :title="title"
                v-else
                class="btn btn-success"
                :data="vessel_certificate_excel"
                :fields="excel_fields"
                worksheet="Vessel Certficates"
                name="Vessel Certficate.xls"
                >Download Excel
              </download-excel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Vessel</th>
                    <th>Certificate Name</th>
                    <th>Certificate Number</th>
                    <th>Issued By</th>
                    <th>Is Active</th>
                    <th>Issue Date</th>
                    <th>Expired Date</th>
                    <th>Place Of Issue</th>
                    <th>Trigger Alert</th>
                    <th>Alert Date</th>
                    <th>Survey Date</th>
                    <th>Survey Type</th>
                    <th>Survey Carried Out By</th>
                    <th>Certficate Sequence Number</th>
                    <th>Condition</th>
                    <th>Attachment</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="18"
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="VesselCertficates.length == 0">
                    <td colspan="18" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(VesselCertficate, at) in VesselCertficates"
                    :key="`VesselCertficate${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>
                      {{
                        VesselCertficate.vessel
                          ? VesselCertficate.vessel.name
                          : ""
                      }}
                    </td>
                    <td>
                      {{ VesselCertficate.certifcate_name }}
                    </td>
                    <td>{{ VesselCertficate.certificate_number }}</td>
                    <td>{{ VesselCertficate.issued_by }}</td>
                    <td>
                      {{ VesselCertficate.is_active == true ? "YES" : "NO" }}
                    </td>
                    <td>{{ VesselCertficate.issued_date | ddmmyyyy }}</td>
                    <td>{{ VesselCertficate.expired_date | ddmmyyyy }}</td>
                    <td>{{ VesselCertficate.place_of_issue }}</td>

                    <td>
                      {{
                        VesselCertficate.trigger_alert == true ? "YES" : "NO"
                      }}
                    </td>
                    <td>{{ VesselCertficate.alert_date | ddmmyyyy }}</td>
                    <td>{{ VesselCertficate.survey_date | ddmmyyyy }}</td>
                    <td>
                      {{ VesselCertficate.survey_type }}
                    </td>
                    <td>
                      {{ VesselCertficate.survey_carried_out_by }}
                    </td>
                    <td>{{ VesselCertficate.certificate_sequence_number }}</td>
                    <td>{{ VesselCertficate.condition }}</td>
                    <td>
                      <img
                        v-if="VesselCertficate.attchment"
                        :src="`${mediaUrl + VesselCertficate.attchment}`"
                        alt=""
                        srcset=""
                      />
                      <span v-else></span>
                    </td>
                    <td>
                      <div>
                        <router-link
                          :to="`/planned-maintenance/vessel-certificates/${VesselCertficate.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(VesselCertficate.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "VesselCertficate",
  data() {
    return {
      VesselCertficates: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      vessel_certificate_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        Vessel: "vessel",
        "Certificate Name": "certifcate_name",
        "Certificate Number": "certificate_number",
        "Issued By": "issued_by",
        "Is Active": "is_active",
        "Issue Date": "issued_date",
        "Expired Date": "expired_date",
        "Place Of Issue": "place_of_issue",
        "Trigger Alert": "trigger_alert",
        "Alert Date": "alert_date",
        "Survey Date": "survey_date",
        "Survey Type": "survey_type",
        "Survey Carried Out By": "survey_carried_out_by",
        "Certficate Sequence Number": "certificate_sequence_number",
        Condition: "condition",
      },
      ExportVesselCertficates: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let VesselCertficates = await axios.get(
        `/vessel_certificates?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.VesselCertficates = VesselCertficates.data.data;
      this.count = VesselCertficates.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let VesselCertficates = await axios.get(
        `/vessel_certificates?search=${this.searchData}`
      );
      this.VesselCertficates = VesselCertficates.data.data;
      this.count = VesselCertficates.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Vessel Certificates Data";
      this.vessel_certificate_excel = [];
      let ExportVesselCertficates = [];
      ExportVesselCertficates = await axios.get(`/vessel_certificates`);
      this.ExportVesselCertficates = ExportVesselCertficates.data.data;
      let sr_no = 1;
      this.ExportVesselCertficates.forEach((VesselCertficate) => {
        this.vessel_certificate_excel.push({
          sr_no: sr_no,
          vessel: VesselCertficate.vessel ? VesselCertficate.vessel.name : "",
          certifcate_name: VesselCertficate.certifcate_name
            ? VesselCertficate.certifcate_name
            : "",
          certificate_number: VesselCertficate.certificate_number
            ? VesselCertficate.certificate_number
            : "",
          issued_by: VesselCertficate.issued_by
            ? VesselCertficate.issued_by
            : "",
          is_active: VesselCertficate.is_active == true ? "YES" : "NO",
          issued_date: VesselCertficate.issued_date
            ? VesselCertficate.issued_date
            : "",
          expired_date: VesselCertficate.expired_date
            ? VesselCertficate.expired_date
            : "",
          place_of_issue: VesselCertficate.place_of_issue
            ? VesselCertficate.place_of_issue
            : "",
          trigger_alert: VesselCertficate.trigger_alert == true ? "YES" : "NO",
          alert_date: VesselCertficate.alert_date
            ? VesselCertficate.alert_date
            : "",
          survey_date: VesselCertficate.survey_date
            ? VesselCertficate.survey_date
            : "",
          survey_type: VesselCertficate.survey_type
            ? VesselCertficate.survey_type
            : "",
          survey_carried_out_by: VesselCertficate.survey_carried_out_by
            ? VesselCertficate.survey_carried_out_by
            : "",
          certificate_sequence_number:
            VesselCertficate.certificate_sequence_number
              ? VesselCertficate.certificate_sequence_number
              : "",
          condition: VesselCertficate.condition
            ? VesselCertficate.condition
            : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=vessel_certificates`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
